/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { bool, string, func, shape, arrayOf, oneOfType, object, number } from "prop-types";
import Select from "react-select";
import FieldLabel from "pages/_components/fields/FieldLabel";

class SelectorInput extends Component {
    inputRef = React.createRef();

    inputGroupRef = React.createRef();

    static propTypes = {
        inputProps: shape({
            name: string.isRequired,
            inputLabelKey: string,
            value: string,
            placeholder: string,
            autofocus: bool,
            type: string,
            inputmode: string,
        }),
        isFocused: bool.isRequired,
        onChange: func.isRequired,
        selectProps: shape({
            name: string.isRequired,
            selectLabelKey: string,
            value: oneOfType([string, object]),
            options: arrayOf(
                shape({
                    label: string.isRequired,
                    value: string.isRequired,
                }),
            ),
        }),
        toggleIsFocused: func.isRequired,
        onBlur: func,
        inputMaxLength: number,
        idField: string.isRequired,
        placeholder: string,
        onClickInput: func,
    };

    static defaultProps = {
        onBlur: () => {},
        inputProps: {},
        selectProps: {},
        onClickInput: () => {},
        placeholder: undefined,
        inputMaxLength: undefined,
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClick, false);
    }

    handleClick = ({ target }) => {
        const { isFocused, toggleIsFocused, onBlur } = this.props;

        if (this.inputGroupRef.current.contains(target) && !isFocused) {
            toggleIsFocused();
        }

        if (!this.inputGroupRef.current.contains(target) && isFocused) {
            toggleIsFocused();
            onBlur();
        }
    };

    handleKeyPress = (event) => {
        const { inputProps } = this.props;
        if (inputProps.type === "number" && (event.key === "-" || event.key === ".")) {
            event.preventDefault();
        }
    };

    handleChange = (event) => {
        const inputValue = event.target.value;
        const { inputMaxLength, onChange, selectProps } = this.props;
        if (inputMaxLength && inputValue.length > inputMaxLength) {
            return;
        }
        onChange(selectProps.value, inputValue);
    };

    render() {
        const { selectProps, inputProps, onChange, inputMaxLength, idField, placeholder, onClickInput } = this.props;

        return (
            <div className="input-group" ref={this.inputGroupRef}>
                <FieldLabel hideLabel labelKey={selectProps.selectLabelKey} mode="edit" idField={idField} />
                <Select
                    id={idField}
                    instanceId={idField}
                    aria-labelledby={`label.${idField}`}
                    className="slideFromBottom flex-container"
                    searchable={false}
                    onChange={(selectValue) => onChange(selectValue, inputProps.value)}
                    clearable={false}
                    placeholder=""
                    optionClassName="needsclick"
                    {...selectProps}
                />
                <FieldLabel hideLabel labelKey={inputProps.inputLabelKey} mode="edit" idField={`${idField}.number`} />
                <input
                    id={`${idField}.number`}
                    className="form-control"
                    type={inputProps.type !== undefined ? inputProps.type : "text"}
                    inputMode={inputProps.inputMode}
                    autoComplete="off"
                    placeholder={placeholder}
                    ref={this.inputRef}
                    maxLength={inputMaxLength}
                    {...inputProps}
                    onClick={onClickInput}
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus={inputProps.autofocus}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyPress}
                />
            </div>
        );
    }
}

export default SelectorInput;
